import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Response } from 'express';
import { RESPONSE_CODE } from 'src/app/helper/class/app-constant';
import { UrlServices } from 'src/app/helper/class/url-services';
import { cloneData } from 'src/app/helper/class/utilityHelper';
import { formBuilderData, ResponseData, tableBuilder, tblFilterQuery } from 'src/app/helper/interface/response';
import { AuthService } from 'src/app/helper/service/auth.service';
import { InvoiceViewComponent } from 'src/app/modules/invoice/component/invoice-view/invoice-view.component';
import { INVOICE_LIST } from 'src/app/modules/invoice/helper/invoice-form';
import { InvoiceApiService } from 'src/app/modules/invoice/service/invoice-api.service';
import { ModalService } from 'src/app/shared/service/modal.service';

@Component({
  selector: 'app-patient-invoice-pending-widget',
  templateUrl: './patient-invoice-pending-widget.component.html',
  styleUrl: './patient-invoice-pending-widget.component.scss'
})
export class PatientInvoicePendingWidgetComponent implements OnInit {
  constructor(
    private router: Router,
    private invoiceApi: InvoiceApiService,
    private modalService: ModalService,
    private activatedRoute: ActivatedRoute,
    private auth: AuthService
  ) { }
  invoiceList;
  invoiceId: string = ''
  loading: boolean = false
  mode = 'EDIT'
  urlService = UrlServices.PAGE_URL;
  noDataFound: boolean = false;
  LIST_COL: formBuilderData[] = cloneData(INVOICE_LIST)
  theme_color = this.auth.currentSettingValue?.theme_color || '#a5bdfd';
  ngOnInit(): void {
    this.invoiceId = this.activatedRoute.snapshot.queryParams['id'] || '';
    if (this.invoiceId && this.mode) {
      this.openInvoiceModal(this.invoiceId)
    }
    this.invoiceDetails();
  }

  tableConfig: tableBuilder = {
    name: 'All',
    action: [],
    column: this.LIST_COL,
    showFilter: true,
    isLazy: true
  }

  getListData = async (e: tblFilterQuery): Promise<any> => {
    return this.invoiceApi.getList(e).then((res: ResponseData) => {
      if (res.statusCode === RESPONSE_CODE.SUCCESS) {
        let result = res.result?.data || [];
        this.noDataFound = result.length === 0;
        if (result.length === 0) {
          return [];
        }

        let invoiceResult = result.slice(0, 5);
        invoiceResult.map((invId: any) => {
          const route = `${this.urlService.INVOICE.PAYMENTVIEW.URL}?id=${invId.invoice_fk_id}&mode=EDIT`;
          invId.invoice_id = `<a href="${route}"><strong>${invId.invoice_id}</strong></a>`;
        })
        return invoiceResult;
      } else {
        this.noDataFound = true;
        return [];
      }
    }).catch(() => {
      this.noDataFound = true;
      return [];
    });
  };


  openInvoiceList() {
    this.router.navigate([UrlServices.PAGE_URL.INVOICE.LIST.URL], { queryParams: {} })
  }
  invoiceDetails() {
    this.loading = true;
    this.invoiceApi.invoiceDetails().then((a: any) => {
      this.invoiceList = a.result;
    }).finally(() => this.loading = false);

  }
  openInvoiceModal(id) {
    this.modalService.openModal(InvoiceViewComponent, { patient_fk_id: id, mode: 'EDIT' }, 'modal-xl').then((res: any) => {
      if (res.reload) {
        this.invoiceDetails();
      }
    });
  }
}


